// Generated by ReScript, PLEASE EDIT WITH CARE


function getNextStep(step) {
  switch (step) {
    case /* CaptureNames */0 :
        return /* CaptureEmail */1;
    case /* CaptureEmail */1 :
        return /* CapturePassword */2;
    case /* CapturePassword */2 :
        return /* CapturePhoneNumber */3;
    case /* CapturePhoneNumber */3 :
    case /* ConfirmSecurityCode */4 :
        return /* ConfirmSecurityCode */4;
    
  }
}

function getPrevStep(step) {
  switch (step) {
    case /* CaptureNames */0 :
    case /* CaptureEmail */1 :
        return /* CaptureNames */0;
    case /* CapturePassword */2 :
        return /* CaptureEmail */1;
    case /* CapturePhoneNumber */3 :
        return /* CapturePassword */2;
    case /* ConfirmSecurityCode */4 :
        return /* CapturePhoneNumber */3;
    
  }
}

function getStepIndex(step) {
  return step + 1 | 0;
}

export {
  getNextStep ,
  getPrevStep ,
  getStepIndex ,
}
/* No side effect */
